import * as React from 'react';
import FormSetup from '../../../../../components/Forms/FormSetup';
import { MasterConfigs } from '../../../../../interfaces/entity';
import { offerLetterConfig } from '../../../../../entity/HRM/offerLetterConfig';
import dayjs from 'dayjs';

const OfferLetterForm = ({ isVisible, onClose, selected, level }) => {
    const [visible, setVisible] = React.useState(isVisible);
    const [activeUser, setActive] = React.useState(selected);

    React.useEffect(() => {
        setActive(selected)
    }, [selected])


    React.useEffect(() => {
        setVisible(isVisible)
    }, [isVisible])

    const setForm = (e) => {
        if (e) {
            const prePopulate = {
                candidate: selected?._id,
                joiningDate: dayjs(selected?.joiningDate),
                yearlyPackage: selected?.offeredCTC
            }
            e.setFieldsValue(prePopulate)
        }
    }

    const config: MasterConfigs = {
        ...offerLetterConfig,
    }


    return <FormSetup id={selected?.offerLetters?._id} config={config} open={visible} onClose={onClose} isModal={false} form={(e) => setForm(e)} />
};

export default OfferLetterForm;